package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TriggerTestRunResponse(
    @SerialName("run_id") val runId: String
)
